import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

// Global 428 hook — emits an event that any component can listen to and
// re-execute the request after NIP verification.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 428) {
      const ev = new CustomEvent('resico:nip-required', { detail: { config: error.config } });
      window.dispatchEvent(ev);
    }
    return Promise.reject(error);
  }
);

export const apiErr = (e) => {
  if (e?.code === 'ECONNABORTED' || /timeout/i.test(e?.message || '')) {
    return 'Tiempo de espera agotado. Verifica tu conexión e intenta de nuevo.';
  }
  if (!e?.response) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return 'Sin conexión a internet. Reconéctate e intenta de nuevo.';
    }
    return 'No se pudo contactar al servidor. Verifica que el backend esté disponible.';
  }
  const status = e.response.status;
  const d = e.response.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(', ');
  if (d && typeof d.msg === 'string') return d.msg;
  if (status === 401) return 'Credenciales incorrectas.';
  if (status === 403) return 'Acceso no permitido.';
  if (status === 404) return 'Recurso no encontrado.';
  if (status === 428) return 'NIP requerido para modificar este periodo declarado.';
  if (status === 429) return 'Demasiados intentos. Intenta más tarde.';
  if (status === 502 || status === 503 || status === 504) {
    return 'El servidor no está disponible (backend caído o reiniciando). Intenta en unos segundos.';
  }
  if (status >= 500) return 'Error interno del servidor. Intenta más tarde.';
  return e?.message || 'Error inesperado.';
};

export const apiErrKind = (e) => {
  if (e?.code === 'ECONNABORTED' || /timeout/i.test(e?.message || '')) return 'timeout';
  if (!e?.response) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'offline';
    return 'backend_down';
  }
  const s = e.response.status;
  if (s === 401) return 'bad_credentials';
  if (s === 428) return 'nip_required';
  if (s === 429) return 'rate_limited';
  if (s === 422 || s === 400) return 'validation';
  if (s === 502 || s === 503 || s === 504) return 'backend_down';
  return 'other';
};
